import React from 'react';

import Button from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import {useShown} from '@pb/kit-hooks-use-shown';

import {AddAttendeeModal} from './add-attendee.modal';

type Props = {
    onAdd: () => void,
    accountId: number,
};

export const AddAttendee = ({onAdd, accountId}: Props) => {
    const {onClick, onClose, shown} = useShown();

    return (
        <>
            <Button variant="Type.PRIMARY" onClick={onClick}>
                Add Attendee
            </Button>
            <Dialog
                shown={shown}
                setShown={onClose}
                wrapperProps={{style: {width: 350}}}>
                <AddAttendeeModal accountId={accountId} onClose={onClose} onAdd={onAdd}/>
            </Dialog>
        </>
    );
};
